import { SOURCE_KEY } from '../constants'


/**
 * @props {object} message
 * @props {string} message.masterOrigin
 * @props {string} message.origin
 * @props {object} message.payload
 * @props {object} message.payload.consents
 * @props {number} message.payload.createdAt
 * @props {string} message.source
 *
 * @returns {boolean}
 */
export default function validateMessage({ masterOrigin, origin, payload, source }) {
  if ( source !== SOURCE_KEY ) {
    return false
  }

  if ( origin !== masterOrigin ) {
    console.debug('Ignoring message: origin (%o) does not match master origin (%o)',
                  origin,
                  masterOrigin)
    return false
  }

  if ( !payload ) {
    return false
  }

  return Boolean(payload?.consents?.id)
}
